import * as React from 'react';
export const IcCallChat = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.62 15.86a1.998 1.998 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0S8.14 13 7.43 12.33a1.001 1.001 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1a2 2 0 00-.56 1.13c-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.72-.75zM17.5 3h-3a3.49 3.49 0 00-1.19 6.78L13 11.09a.74.74 0 00.31.78.72.72 0 00.42.13.7.7 0 00.42-.13L16.9 10h.6a3.5 3.5 0 100-7z'
      fill='currentColor'
    />
  </svg>
);
